import { surplusSettingsContracts } from "./surplus-settings.contract";
import { replenishmentDetailContracts } from "./replenishment-detail.contract";
import { leadTimeSettingsContracts } from "./lead-time-settings.contract";
import { inventorySnapshotsContracts } from "./inventory-snapshots.contract";
import { gainsRawDataSearchContracts } from "./gains-raw-data-search.contract";
import { supplierProductsContracts } from "./supplier-products.contract";
import { productSupercedesContracts } from "./product-supercedes.contract";
import { supplierWarehouseConstraintsContracts } from "./supplier-warehouse-constraints.contract";
import { replenishmentSuggestionsContracts } from "./replenishment-suggestions.contract";
import { queryBuilderContracts } from "./query-builder.contract";
import { procSavedReportsContracts } from "./saved-reports.contract";
import { inventoryPolicyOverridesContracts } from "./inventory-policy-overrides.contract";
import { returnCandidatesContracts } from "./return-candidates.contract";
import { demandOverridesContracts } from "./demand-overrides.contract";
import { leadTimesContracts } from "./lead-times.contract";
import { leadTimeOverridesContracts } from "./lead-time-overrides.contract";
import { forecastFactorsContracts } from "./forecast-adjustment-factors.contract";
import { overridesContracts } from "./overrides.contract";
import { processingRecipesContracts } from "./processing-recipes.contract";
import { millableClassificationsContracts } from "./millable-classifications.contract";
import { forecastRunsContracts } from "./forecast-runs.contract";
import { forecastDetailContracts } from "./forecast-detail.contract";
import { forecastApprovalsContracts } from "./forecast-approvals.contract";
import { forecastNotesContracts } from "./forecast-notes.contract";
import { salesHistoryTransfersContracts } from "./sales-history-transfers.contract";
import { procurementExportsContracts } from "./exports.contract";
import { forecastOutlierRulesContracts } from "./forecast-outlier-rules.contract";
import { forecastSettingsContracts } from "./forecast-settings.contract";
import { purchaseOrderLinesContracts } from "./purchase-order-lines.contract";
import { freightOptionsContracts } from "./freight-options.contract";
import { purchaseOrderSubmissionContracts } from "./purchase-order-submission.contract";

export const procurementContracts = {
  replenishmentDetail: replenishmentDetailContracts,
  leadTimeSettings: leadTimeSettingsContracts,
  surplusSettings: surplusSettingsContracts,
  inventorySnapshots: inventorySnapshotsContracts,
  gainsRawData: gainsRawDataSearchContracts,
  supplierProducts: supplierProductsContracts,
  productSupercedes: productSupercedesContracts,
  supplierWarehouseConstraints: supplierWarehouseConstraintsContracts,
  replenishmentSuggestions: replenishmentSuggestionsContracts,
  queryBuilder: queryBuilderContracts,
  savedReports: procSavedReportsContracts,
  inventoryPolicyOverrides: inventoryPolicyOverridesContracts,
  returnCandidates: returnCandidatesContracts,
  demandOverrides: demandOverridesContracts,
  leadTimes: leadTimesContracts,
  leadTimeOverrides: leadTimeOverridesContracts,
  forecastFactors: forecastFactorsContracts,
  overrides: overridesContracts,
  processingRecipes: processingRecipesContracts,
  millableClassifications: millableClassificationsContracts,
  forecastRuns: forecastRunsContracts,
  forecastDetail: forecastDetailContracts,
  forecastApprovals: forecastApprovalsContracts,
  forecastNotes: forecastNotesContracts,
  salesHistoryTransfers: salesHistoryTransfersContracts,
  exports: procurementExportsContracts,
  forecastOutlierRules: forecastOutlierRulesContracts,
  forecastSettings: forecastSettingsContracts,
  purchaseOrderLines: purchaseOrderLinesContracts,
  freightOptions: freightOptionsContracts,
  purchaseOrderSubmission: purchaseOrderSubmissionContracts,
} as const;

export * from "./inventory-snapshots.contract";
export * from "./gains-raw-data-search.contract";
export * from "./supplier-products.contract";
export * from "./product-supercedes.contract";
export * from "./supplier-warehouse-constraints.contract";
export * from "./replenishment-suggestions.contract";
export * from "./line-stock-position.contract";
export * from "./line-supply-demand.contract";
export * from "./query-builder.contract";
export * from "./saved-reports.contract";
export * from "./inventory-policy-overrides.contract";
export * from "./return-candidates.contract";
export * from "./demand-overrides.contract";
export * from "./lead-times.contract";
export * from "./lead-time-overrides.contract";
export * from "./forecast-adjustment-factors.contract";
export * from "./overrides.contract";
export * from "./override-window";
export * from "./processing-recipes.contract";
export * from "./millable-classifications.contract";
export * from "./forecast-runs.contract";
export * from "./forecast-detail.contract";
export * from "./forecast-approvals.contract";
export * from "./forecast-notes.contract";
export * from "./sales-history-transfers.contract";
export * from "./forecast-outlier-rules.contract";
export * from "./freight-options.contract";
export * from "./purchase-order-submission.contract";
export * from "./forecast-settings.contract";
export * from "./replenishment-plan-validation";
export * from "./exports.contract";

export * from "./replenishment-detail.contract";
export * from "./lead-time-settings.contract";
export * from "./purchase-order-lines.contract";
export * from "./stock-surplus";

export * from "./surplus-settings.contract";
